// extracted by mini-css-extract-plugin
module.exports = {"productDescriptionTab":"ProductDetailsTabs_productDescriptionTab__h45rg"};